export const hexToRgbArray = (hex: string): number[] => {
  const hexadecimalBase = 16;
  const redHexPart = hex.slice(1, 3);
  const greenHexPart = hex.slice(3, 5);
  const blueHexPart = hex.slice(5, 7);

  const red = parseInt(redHexPart, hexadecimalBase);
  const green = parseInt(greenHexPart, hexadecimalBase);
  const blue = parseInt(blueHexPart, hexadecimalBase);

  return [red, green, blue];
}
